/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import CodeEditor from './CodeEditor';
import JsonEditor from './CodeEditor/JsonEditor';
import { EnvironmentMissing, EnvironmentPanel, EnvironmentProvider, EnvironmentStatus, useEnvironment } from './Environment';
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import ThemeSelector from './ThemeSelector';

export {
  AvatarDropdown,
  AvatarName,
  CodeEditor,
  EnvironmentMissing,
  EnvironmentPanel,
  EnvironmentProvider,
  EnvironmentStatus,
  Footer,
  JsonEditor,
  Question,
  SelectLang,
  ThemeSelector,
  useEnvironment,
};
